export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <svg viewBox="0 0 40 40" className="h-9 w-9 shrink-0" aria-hidden="true">
        <rect width="40" height="40" fill="#0A0C10" />
        <path d="M7 31V9l13 15L33 9v22" fill="none" stroke="#F5F7FA" strokeWidth="4" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-condensed text-xl font-bold tracking-[0.08em] text-white">
            MANGALAM
          </span>
          <span className="mt-0.5 block font-mono text-[13px] font-bold tracking-[0.32em] text-ember">
            GROUP
          </span>
        </span>
      )}
    </span>
  );
}
